import { Form } from 'antd';
import { FormProps } from 'antd/lib/form';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

export const LoginGrid = styled.div`
  display: grid;
  grid-template-columns: 53% 46%;
  grid-template-rows: 100%;
  width: 100vw;
  height: 100vh;
  background: #eeeff3;
`;

export const LoginImgWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginImg = styled.img`
  max-height: 100vh;
  margin-right: -5rem;
`;

export const LoginFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const logoHeight = '4.3rem';
export const LoginLogo = styled.div`
  flex: 0 0 ${logoHeight};
  display: flex;
  align-items: center;
  margin-top: -${logoHeight};
  margin-bottom: 0.7rem;
`;

export const LoginForm: FunctionComponent<FormProps> = styled(Form)`
  border-radius: 0.1rem;
  padding: 2.5rem 2rem;
  background: white;
  max-width: 34rem;

  label {
    display: none;
  }

  h2 {
    margin-bottom: 1rem;
    font-weight: bold;
  }

  .ant-form-item-extra {
    display: none;
  }
`;
